import React, { useEffect, useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import { api } from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/faqs").then(({ data }) => setItems(data)); }, []);
  return (
    <PublicLayout>
      <section className="container-x pt-16 pb-8">
        <div className="overline mb-4">FAQ</div>
        <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter">Everything you need to know.</h1>
      </section>
      <section className="container-x pb-24 max-w-3xl">
        <Accordion type="single" collapsible className="space-y-2" data-testid="faq-accordion">
          {items.map((f) => (
            <AccordionItem key={f.faq_id} value={f.faq_id} className="glass rounded-xl border-none px-4">
              <AccordionTrigger className="hover:no-underline text-left">{f.question}</AccordionTrigger>
              <AccordionContent className="text-ink-700 leading-relaxed">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </PublicLayout>
  );
}
